import {CommentText} from './styles.js'
import React, { useRef } from 'react';
import {TextXS} from '@/pages/designSystem/Fonts';
import { MathJax } from 'better-react-mathjax';
import { TestingQuestion } from '@/components/features/testing/TestingForm/styles';
import { sanitizeHTML } from '@/core/hooks/useSanitizedHTML';

type AnswerCommentProps = {
    comment: string | undefined
}

const AnswerComment: React.FC<AnswerCommentProps> = (
    {
        comment,
    }
) => {

    const contentRef = useRef<HTMLDivElement>(null);
    const sanitizedHTMLComment = sanitizeHTML(comment);
    const commentText = <TextXS ref={contentRef} dangerouslySetInnerHTML={{ __html: sanitizedHTMLComment }} />;

    return (
        <CommentText>
            <MathJax dynamic>{commentText}</MathJax>
        </CommentText>
    )
}

export default AnswerComment